import {NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {RouterLink} from "@angular/router";
import {GestionUsuariosResumenComponent} from "./gestion-usuarios-resumen.component";
import {WidgetResumenUsuariosModule} from "../widget-resumen-usuarios/widget-resumen-usuarios.module";
import {WidgetDistribucionRolesModule} from "../widget-distribucion-roles/widget-distribucion-roles.module";

@NgModule({
  declarations: [
    GestionUsuariosResumenComponent
  ],
  exports: [
    GestionUsuariosResumenComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    RouterLink,
    WidgetResumenUsuariosModule,
    WidgetDistribucionRolesModule,
  ]
})
export class GestionUsuariosResumenModule {
}
